/**
 * Ledes that carry a live rate.
 *
 * An article lede may quote a price through the same span the bodies use —
 * `<span class="mono" data-rate="esim-japan:mb">$0.0021</span>` — so
 * sync-content-rates keeps the figure equal to prices.json. Every renderer
 * treated the lede as plain text and escaped it, and 254 country ledes plus
 * the France post printed the tag itself: in the server HTML crawlers index,
 * in the blog listing and, for the France post, on the hydrated page every
 * visitor reads (found 2026-09-30).
 *
 * `ledeHtml` escapes everything except that one span shape; `ledeText` drops
 * the tag and keeps its figure, for places that take text only (markdown,
 * meta descriptions, card excerpts). Both packages render ledes, so the rule
 * lives here once.
 */
const RATE_SPAN = /<span class="mono" data-rate="([^"<>]*)">([^<]*)<\/span>/g;
function escapeHtml(s) {
    return s
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}
/** Escaped HTML with the live-rate span (and nothing else) kept as markup. */
export function ledeHtml(s) {
    let out = '';
    let last = 0;
    for (const m of s.matchAll(RATE_SPAN)) {
        const at = m.index ?? 0;
        out += escapeHtml(s.slice(last, at));
        out += `<span class="mono" data-rate="${escapeHtml(m[1] ?? '')}">${escapeHtml(m[2] ?? '')}</span>`;
        last = at + m[0].length;
    }
    return out + escapeHtml(s.slice(last));
}
/** Plain text: the rate span is replaced by the figure it shows. */
export function ledeText(s) {
    return s.replace(RATE_SPAN, '$2');
}
